import { Box, Table } from "@chakra-ui/react";
import { ReactNode } from "react";
import { crm } from "../../../theme";

// Tabelas da tela de processo (design system: card com borda, cabeçalho subtle sem caixa-alta)
export const thProps = {
  bg: crm.subtle,
  color: crm.textMuted,
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "none" as const,
  letterSpacing: "normal",
  borderColor: crm.border,
  py: "10px",
};

export const tdProps = { borderColor: crm.border, fontSize: "13px", color: crm.text, py: "10px" };

export const TableCard = ({ children }: { children: ReactNode }) => (
  <Box border={`1px solid ${crm.border}`} borderRadius={crm.radiusSm} overflowX="auto">
    <Table size="sm">{children}</Table>
  </Box>
);

/** NCM 40111000 -> 4011.10.00 (mantém o valor original se não tiver 8 dígitos). */
export const formatNcm = (ncm?: string | null) => {
  const digits = ncm?.replace(/\D/g, "") ?? "";
  return digits.length === 8 ? `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}` : ncm || "—";
};
